import { getRecordState } from '@/utils';
class LayerPlugin {
  public canvas;
  public editor;
  public store;
  static pluginName = 'LayerPlugin';
  static apis = ['up', 'upTop', 'down', 'downTop'];
  constructor(canvas, editor, { store }) {
    this.canvas = canvas;
    this.editor = editor;
    this.store = store;
  }

  _getWorkspace() {
    return this.canvas.getObjects().find(item => item.id === 'workspace');
  }

  _workspaceSendToBack() {
    const workspace = this._getWorkspace();
    workspace && workspace.sendToBack();
  }

  afterSorted(object) {
    const { store } = this;
    const appState = store.state.app;
    object.$$manualSorted = 1;
    store.commit(
      'app/SET_objectUIDs',
      $XJCanvas.getObjects().map(i => i.$$uid)
    );
    store.commit('app/ADD_MANUAL_SORTED_UIDS', object.$$uid);
    store.dispatch('record/addState', getRecordState(appState));
  }

  up() {
    const actives = this.canvas.getActiveObjects();
    if (actives && actives.length === 1) {
      const activeObject = this.canvas.getActiveObjects()[0];
      if (activeObject) {
        activeObject.bringForward();
        this.afterSorted(activeObject);
      }
      this.canvas.renderAll();
      this._workspaceSendToBack();
    }
  }

  upTop() {
    const actives = this.canvas.getActiveObjects();
    if (actives && actives.length === 1) {
      const activeObject = this.canvas.getActiveObjects()[0];
      if (activeObject) {
        activeObject.bringToFront();
        this.afterSorted(activeObject);
      }
      this.canvas.renderAll();
      this._workspaceSendToBack();
    }
  }

  down() {
    const actives = this.canvas.getActiveObjects();
    if (actives && actives.length === 1) {
      const activeObject = this.canvas.getActiveObjects()[0];
      if (activeObject) {
        activeObject.sendBackwards();
        this.afterSorted(activeObject);
      }
      this.canvas.renderAll();
      this._workspaceSendToBack();
    }
  }

  downTop() {
    const actives = this.canvas.getActiveObjects();
    if (actives && actives.length === 1) {
      const activeObject = this.canvas.getActiveObjects()[0];
      if (activeObject) {
        activeObject.sendToBack();
        this.afterSorted(activeObject);
      }
      this.canvas.renderAll();
      this._workspaceSendToBack();
    }
  }

  contextMenu() {
    const activeObject = this.canvas.getActiveObject();
    if (activeObject) {
      return [
        {
          text: '图层管理',
          hotkey: '❯',
          subitems: [
            {
              text: '上一个',
              // hotkey: 'key',
              onclick: () => this.up(),
            },
            {
              text: '下一个',
              // hotkey: 'key',
              onclick: () => this.down(),
            },
            {
              text: '置顶',
              // hotkey: 'key',
              onclick: () => this.upTop(),
            },
            {
              text: '置底',
              // hotkey: 'key',
              onclick: () => this.downTop(),
            },
          ],
        },
      ];
      // return [{ text: '复制', hotkey: 'Ctrl+V', disabled: false, onclick: () => this.clone() }];
    }
  }

  destroy() {
    console.log('pluginDestroy');
  }
}

export default LayerPlugin;
